<ngx-skeleton-loader
  *ngIf="itemsLoading$ | async; else itemsTable"
  count="2"
  appearance="line"
></ngx-skeleton-loader>

<ng-template #itemsTable>
  <app-items-table
    [items]="items$"
    [canEdit]="canEdit"
    [currency]="currency$ | async"
    [currencyRate]="currencyRate$ | async"
    [eposMode]="eposMode"
    (itemDeleteRequested)="delete($event)"
    (itemEditRequested)="edit($event)"
  ></app-items-table>
</ng-template>

@if (eposMode === false) {
  <app-retail-item-search
    *ngIf="preview === false"
    [canAdd]="canAdd"
    [showGridButton]="showGridButton"
    [parentType]="parentType"
  ></app-retail-item-search>
}
